var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.18 16.6026H14.883L22.4829 1.74641L19.0691 0L10.9857 15.8012C9.90141 17.9207 11.4407 20.4372 13.8215 20.4372H23.18V16.6026ZM0 7.65079H8.29704L0.69708 22.507L4.11093 24.2534L12.1943 8.45222C13.2786 6.3327 11.7393 3.81617 9.3585 3.81617H0V7.65079Z",
    fill: "url(#paint0_linear_47537_77318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47537_77318",
    x1: 11.59,
    y1: 0,
    x2: 11.59,
    y2: 38.2611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiber);
export default __webpack_public_path__ + "static/media/Fiber.e284c558be31c9fe2e991777f7dfdd8c.svg";
export { ForwardRef as ReactComponent };